export default "__VITE_ASSET__kMZtH8e5__"